import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLocale, Country } from "@/contexts/LocaleContext";

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { locale, setCountry, availableCountries } = useLocale();

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-muted/50 border border-border/50 hover:bg-muted transition-colors"
      >
        <span className="text-base">{locale.flag}</span>
        <span className="text-xs font-medium text-foreground">
          {locale.language.toUpperCase()}
        </span>
        <ChevronDown
          size={14}
          className={`text-muted-foreground transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, y: -10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -10, scale: 0.95 }}
              transition={{ duration: 0.15 }}
              className="absolute top-full right-0 mt-2 z-50 min-w-[180px] rounded-lg border border-border bg-card shadow-xl overflow-hidden"
            >
              {availableCountries.map((config) => (
                <button
                  key={config.country}
                  onClick={() => {
                    setCountry(config.country as Country);
                    setIsOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-muted/50 transition-colors ${
                    config.country === locale.country ? "bg-primary/10" : ""
                  }`}
                >
                  <span className="text-xl">{config.flag}</span>
                  <span className="text-sm font-medium text-foreground">
                    {config.name}
                  </span>
                  {config.country === locale.country && (
                    <div className="ml-auto w-2 h-2 rounded-full bg-primary" />
                  )}
                </button>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageSelector;
